import styled from 'styled-components';

export const StyledText = styled.span`
padding: 5px 25px 5px 0;
font-weight: normal;
color: rgb(51, 51, 51);
font-size: 13pt;
font-family: "Segoe UI", "Open Sans", sans-serif;
`;
